import React from "react";

type StringTypeProps = {
  values: string[];
};

export const StringType = (props: StringTypeProps) => {
  if (props.values.length > 1) {
    return (
      <ul style={{ textAlign: "left", paddingLeft: 0 }}>
        {props.values.map((value, index) => (
          <li data-anchor="user-attribute-string" key={index}>
            {value}
          </li>
        ))}
      </ul>
    );
  }
  return <div data-anchor="user-attribute-string">{props.values[0]}</div>;
};
